<span class="select-none cursor-default text-nowrap d-flex">
  <app-animated-checkbox
    *ngIf="checkAllEnabled"
    [selected]="checkAllSelected"
    (clickEvent)="onCheckAllClicked.emit()">
  </app-animated-checkbox>
  <span class="table-sorter-item">{{text}}</span>
</span>
